<template>
  <div class="filter-wrapper">
    <a-form :model="filterData">
      <div class="df">
        <a-form-item label="品牌" name="brandId">
          <a-select
            v-model:value="filterData.brandId"
            placeholder="请选择"
            :options="brands"
            style="width: 150px;margin-right: 20px;"
            @change="initList"
          >
          </a-select>
          <!-- <a-select-option
            :value="item.id"
            :key="key"
            v-for="(item, key) in brands"
            >{{ item.name }}</a-select-option
          > -->
        </a-form-item>
        <a-form-item label="渠道" name="channelId">
          <a-select
            v-model:value="filterData.channelId"
            placeholder="请选择"
            :options="channels"
            style="width: 150px;margin-right: 20px;"
            @change="initList"
          >
          </a-select>
          <!-- <a-select-option
            :value="item.id"
            :key="key"
            v-for="(item, key) in channels"
            >{{ item.name }}</a-select-option
          > -->
        </a-form-item>
        <a-form-item label="站点" name="siteId">
          <a-select
            v-model:value="filterData.siteId"
            placeholder="请选择"
            :options="sites"
            style="width: 150px;margin-right: 20px;"
            @change="initList"
          >
          </a-select>
          <!-- <a-select-option
            :value="item.id"
            :key="key"
            v-for="(item, key) in sites"
            >{{ item.name }}</a-select-option
          > -->
        </a-form-item>
        <a-form-item label="终端" name="terminalId">
          <a-select
            v-model:value="filterData.terminalId"
            placeholder="请选择"
            :options="terminals"
            style="width: 150px;margin-right: 20px;"
            @change="initList"
          >
          </a-select>
          <!-- <a-select-option
            :value="item.id"
            :key="key"
            v-for="(item, key) in terminals"
            >{{ item.name }}</a-select-option
          > -->
        </a-form-item>
        <div class="btn-wrapper">
          <a-button class="mr10" type="primary" @click="initList"
            >查询</a-button
          >
          <a-button class="mr10" @click="resetFilter">重置</a-button>
          <a-button type="primary" @click="addActive(0)">新建活动</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  margin-bottom: 10px;
}
.btn-wrapper {
  margin-left: auto;
}
</style>
